export default "__VITE_ASSET__f66cab07__"